import { buildBillingContext } from '@/apiCalls/billingContext';
import { postUrl } from '@/apiCalls/fetch';
import { selectCountry } from '@/context/display';
import { store } from '@/context/store';

import { ILookupName } from './lookupBusinessNameTypes';

export async function lookupBusinessName(name: string): Promise<ILookupName[]> {
    const country = selectCountry(store.getState());

    return postUrl<ILookupName[]>('/api/abn/list', {
        country,
        name,
        billingContext: buildBillingContext(),
    });
}
